import React, { useMemo } from "react";
import { Box, Container } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { InHouseOffersPreview } from "@zillout/shared-components";

interface PubInHouseOffersSectionProps {
  /** Day-event UUID. Section auto-hides when missing. */
  dayEventUuid?: string;
  /** Theme colors from the pub. When omitted, falls back to white/violet defaults. */
  pubColors?: any;
}

const PubInHouseOffersSection: React.FC<PubInHouseOffersSectionProps> = ({
  dayEventUuid,
  pubColors,
}) => {
  const navigate = useNavigate();

  const reservationTime = useMemo(() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
  }, []);

  if (!dayEventUuid) return null;

  return (
    <Box
      w="100%"
      pt={[6, 6, 6, 12]}
      pb={[6, 6, 6, 12]}
      px={[4, 4, 4, 8]}
      display="flex"
      justifyContent="center"
    >
      <Container maxW="600px" p={0}>
        <InHouseOffersPreview
          eventId={dayEventUuid}
          reservationTime={reservationTime}
          hideWhenEmpty
          pubColors={pubColors}
          onAllOffersClick={() => {
            const params = new URLSearchParams({
              event_id: dayEventUuid,
              reservation_time: reservationTime,
              mode: "view",
            });
            navigate(`/in-house-offers?${params.toString()}`);
          }}
        />
      </Container>
    </Box>
  );
};

export default PubInHouseOffersSection;
